const AppEnv = {
  namespaced: true,

  state: {
    mode: '', // clasmo or 3nosuke
  },
  getters: {
    getMode: state => {
      return state.mode
    },
  },
  mutations: {
    setMode(state, mode) {
      state.mode = mode
    },
  },
  actions: {},
}

export default AppEnv
